// import ParentsEdit from "./assessmentEdit/ParentsEdit";
// import { getAppId, getSysId } from '../../../shared/utils/storage';
import { useEffect, useState } from "react";
import { FaEdit, FaIdCard } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { getSearchInfo } from '../../../shared/utils/storage';

// const AppId = getAppId();
// const SysId = getSysId();

const ParentsInfo = () => {
  const [application, setApplication] = useState()

  useEffect(() => {
    const searchedData = getSearchInfo()
    if (searchedData) {
      setApplication(searchedData?.data)
    }
  }, [])
  //const data = useLocation().state
  const parentInfo = application?.ParentInfo[0]
  // const [parents, setParents] = useState([]);

  const styles = {
    h4: {
      color: '#850505',
      textTransform: 'uppercase',
    }
  };

  useEffect(() => {
    // setParents(getapplicantAss());
  }, []);

  return (
    <>
      <table id="viewTable">
        <tr>
          <th colspan="3">
            <h4>
              <b>Parents Informations</b>
            </h4>
          </th>
          <th
            style={{
              textAlign: "right",
              border: "1px",
            }}
          >
            <b>
              <FaIdCard style={{ fontSize: "23px" }} />
            </b>
            {/* <ParentsEdit /> */}
          </th>
        </tr>
        <tr>
          <td style={{ width: "25%" }}>
            Jina kamili la Baba: <br />{" "}
            <h4 style={styles.h4}>{parentInfo?.FatherFullName}</h4>
          </td>
          <td style={{ width: "25%" }}>
            Tarehe ya Kuzaliwa: <br />{" "}
            <h4 style={styles.h4}>{parentInfo?.FatherDOB}</h4>
          </td>
          <td style={{ width: "25%" }}>
            Nchi: <br />{" "}
            <h4 style={styles.h4}>
              {parentInfo?.FatherCountryName}
            </h4>
          </td>
          <td style={{ width: "25%" }}>
            Eneo: <br />{" "}
            <h4 style={styles.h4}>
              {parentInfo?.FatherTerritoryName}
            </h4>
          </td>
        </tr>
        <tr>
          <td>
            Mkoa: <br />{" "}
            <h4 style={styles.h4}>
              {parentInfo?.FatherRegionName}
            </h4>
          </td>
          <td>
            Wilaya: <br />
            <h4 style={styles.h4}>{parentInfo?.FatherDistrictName}</h4>
          </td>
          <td>
            Kata/Shehia: <br />
            <h4 style={styles.h4}>{parentInfo?.FatherWardName}</h4>
          </td>
          <td>
            Kijiji/Mtaa: <br />
            <h4 style={styles.h4}>{parentInfo?.FatherVillage}</h4>
          </td>
        </tr>
        <tr>
          <td colspan="4"></td>
        </tr>
        <tr>
          <td>
            Jina kamili la Mama: <br />{" "}
            <h4 style={styles.h4}>{parentInfo?.MotherFullName}</h4>
          </td>
          <td>
            Tarehe ya Kuzaliwa: <br />{" "}
            <h4 style={styles.h4}>{parentInfo?.MotherDOB}</h4>
          </td>
          <td>
            Nchi: <br />{" "}
            <h4 style={styles.h4}>
              {parentInfo?.MotherCountryName}
            </h4>
          </td>
          <td>
            Eneo: <br />{" "}
            <h4 style={styles.h4}>
              {parentInfo?.MotherTerritoryName}
            </h4>
          </td>
        </tr>
        <tr>
          <td>
            Mkoa: <br />{" "}
            <h4 style={styles.h4}>
              {parentInfo?.MotherRegionName}
            </h4>
          </td>
          <td>
            Wilaya: <br />
            <h4 style={styles.h4}>{parentInfo?.MotherDistrictName}</h4>
          </td>
          <td>
            Kata/Shehia: <br />
            <h4 style={styles.h4}>{parentInfo?.MotherWardName}</h4>
          </td>
          <td>
            Kijiji/Mtaa: <br />
            <h4 style={styles.h4}>{parentInfo?.MotherVillage}</h4>
          </td>
        </tr>
      </table>
    </>
  );
}

export default ParentsInfo;
